import { useInView } from '../../../hooks/useInView';

const steps = [
  {
    number: '01',
    icon: 'ri-chat-3-line',
    title: 'Primeiro Contato',
    description:
      'Entre em contato pelo WhatsApp ou formulário. Faremos uma conversa inicial para entender sua necessidade e apresentar nossa forma de trabalho.',
  },
  {
    number: '02',
    icon: 'ri-search-2-line',
    title: 'Análise do Caso',
    description:
      'Realizamos uma análise jurídica detalhada da situação do seu imóvel, identificando todos os pontos críticos e oportunidades.',
  },
  {
    number: '03',
    icon: 'ri-lightbulb-flash-line',
    title: 'Elaboração da Estratégia',
    description:
      'Desenvolvemos um plano de ação jurídico personalizado, claro e eficaz, alinhado aos seus objetivos e prazo desejado.',
  },
  {
    number: '04',
    icon: 'ri-check-double-line',
    title: 'Execução e Acompanhamento',
    description:
      'Conduzimos todo o processo com rigor técnico e transparência, mantendo você informado em cada etapa até a conclusão.',
  },
];

export default function HowItWorks() {
  const { ref: headRef, inView: headIn } = useInView();

  return (
    <section id="como-funciona" className="w-full py-24 md:py-32 relative" style={{ background: '#081F3D' }}>
      {/* Decorative top border */}
      <div className="absolute top-0 left-0 right-0 h-px" style={{ background: 'linear-gradient(90deg, transparent, #D4AF37, transparent)' }}></div>
      <div className="absolute bottom-0 left-0 right-0 h-px" style={{ background: 'linear-gradient(90deg, transparent, #D4AF37, transparent)' }}></div>

      <div className="max-w-6xl mx-auto px-6 md:px-12">
        {/* Header */}
        <div
          ref={headRef}
          className={`text-center mb-16 transition-all duration-1000 ${headIn ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
        >
          <div className="flex items-center justify-center gap-4 mb-4">
            <div className="h-px w-16" style={{ background: 'linear-gradient(90deg, transparent, #D4AF37)' }}></div>
            <span className="font-sans text-xs tracking-[3px] uppercase font-medium" style={{ color: '#D4AF37' }}>
              Nosso Processo
            </span>
            <div className="h-px w-16" style={{ background: 'linear-gradient(90deg, #D4AF37, transparent)' }}></div>
          </div>
          <h2 className="font-serif text-3xl md:text-5xl font-bold" style={{ color: '#F5F5F5' }}>
            Como <span style={{ color: '#D4AF37' }}>Funciona</span>
          </h2>
          <p className="font-sans text-sm md:text-base font-light mt-4 max-w-2xl mx-auto" style={{ color: '#D9D9D9' }}>
            Um processo claro, transparente e eficiente do início ao resultado.
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 relative">
          {/* Connector line (desktop only) */}
          <div
            className="absolute top-10 left-0 right-0 h-px hidden lg:block"
            style={{ background: 'linear-gradient(90deg, transparent, rgba(212,175,55,0.3), transparent)', zIndex: 0 }}
          ></div>

          {steps.map((step, i) => (
            <StepCard key={i} step={step} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}

function StepCard({ step, index }: { step: typeof steps[0]; index: number }) {
  const { ref, inView } = useInView();

  return (
    <div
      ref={ref}
      className={`relative z-10 flex flex-col items-center text-center transition-all duration-700 ${
        inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
      }`}
      style={{ transitionDelay: `${index * 150}ms` }}
    >
      {/* Step circle */}
      <div
        className="relative w-20 h-20 flex items-center justify-center rounded-full mb-6"
        style={{ background: '#081F3D', border: '1px solid rgba(212,175,55,0.4)', boxShadow: '0 0 0 6px #081F3D' }}
      >
        <i className={`${step.icon} text-3xl`} style={{ color: '#D4AF37' }}></i>
        {/* Step number badge */}
        <div
          className="absolute -top-2 -right-2 w-7 h-7 flex items-center justify-center rounded-full text-xs font-bold font-sans"
          style={{ background: '#D4AF37', color: '#0A2A52' }}
        >
          {step.number}
        </div>
      </div>

      <h3 className="font-serif text-base font-semibold mb-3" style={{ color: '#F5F5F5' }}>
        {step.title}
      </h3>
      <p className="font-sans text-sm leading-relaxed" style={{ color: '#D9D9D9' }}>
        {step.description}
      </p>
    </div>
  );
}